import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as flexBoxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles } from './template.scss';

export const templateCustomFieldsForm = document.createElement('template');

templateCustomFieldsForm.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${flexBoxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='wrapper'>
    <gz-title fontSize='11' fontWeight='600' class='title' id='custom-fields-title'></gz-title>

    <gz-text id='custom-fields-details-text' class='mt-2' fontSize='12'></gz-text>

    <gz-form-list id='custom-fields-form' class='pr-1 mt-1 d-flex flex-column' useMinWidth></gz-form-list>
  </div>
`;
